import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTwitter,
  faYoutube,
  faSoundcloud,
  faSpotify,
  faFacebook,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import * as styles from "./contact.module.css";

const Contact = () => (
  <section id="contact" className="section-wrapper">
    <h2 className="section-title">
      <a href="#contact">Contact</a>
    </h2>
    <div>
      <ul className={styles.socialsList}>
        <li className={styles.socialsListItem}>
          <a
            href="https://open.spotify.com/artist/7GdwdB1bILr5eseySC7QvX"
            target="_blank"
          >
            <FontAwesomeIcon
              icon={faSpotify}
              size="2x"
              className={styles.socialIcon}
            />
            @MilkyHaze
          </a>
        </li>

        <li className={styles.socialsListItem}>
          <a href="https://soundcloud.com/milkyhaze" target="_blank">
            <FontAwesomeIcon
              icon={faSoundcloud}
              size="2x"
              className={styles.socialIcon}
            />
            @MilkyHaze
          </a>
        </li>

        <li className={styles.socialsListItem}>
          <a href="https://www.instagram.com/milkyhazemusik" target="_blank">
            <FontAwesomeIcon
              icon={faInstagram}
              size="2x"
              className={styles.socialIcon}
            />
            @MilkyHaze
          </a>
        </li>

        <li className={styles.socialsListItem}>
          <a
            href="https://www.youtube.com/channel/UCrh_hkzGsNoE70yXdmPPpfw"
            target="_blank"
          >
            <FontAwesomeIcon
              icon={faYoutube}
              size="2x"
              className={styles.socialIcon}
            />
            @MilkyHazeMusik
          </a>
        </li>

        <li className={styles.socialsListItem}>
          <a href="https://www.facebook.com/milkyhazemusik/" target="_blank">
            <FontAwesomeIcon
              icon={faFacebook}
              size="2x"
              className={styles.socialIcon}
            />
            @MilkyHazeMusik
          </a>
        </li>

        <li className={styles.socialsListItem}>
          <a href="https://twitter.com/milkyhazemusik" target="_blank">
            <FontAwesomeIcon
              icon={faTwitter}
              size="2x"
              className={styles.socialIcon}
            />
            @MilkyHazeMusik
          </a>
        </li>
      </ul>
      <ul className={styles.socialsList}>
        <li className={styles.socialsListItem}>
          <a href="mailto:milkyhazemusik@gmail.com" target="_blank">
            <FontAwesomeIcon
              icon={faEnvelope}
              size="2x"
              className={styles.socialIcon}
            />
            milkyhazemusik@gmail.com
          </a>
        </li>
      </ul>
    </div>
  </section>
);

export default Contact;
